import styled from 'styled-components'

const DropZone = styled.div`
  border-radius: 0.2rem;
  min-height: 8rem;
  background: ${({ $over }) => ($over ? '#f1f3f5' : 'transparent')};
`

export default DropZone
